import { createFileRoute } from '@tanstack/react-router';

import { ShowcasePage } from '#features/design-system';

/**
 * Витрина дизайн-системы: всё, что есть в системе, одной страницей.
 *
 * Значения читаются из темы в момент показа, компоненты показывают себя сами файлами
 * `*.showcase.tsx`, которые страница собирает по маске. Скопированных строкой значений здесь
 * нет ни одного - за этим следит `scripts/check-showcase-files.mjs`: компонент без своего
 * showcase роняет сборку.
 *
 * Прежняя страница на этом адресе была одним файлом на 2600 строк, где значения токенов и
 * счётчики использований лежали вписанными вручную. Они разошлись с темой за месяц: `fg.link`
 * был подписан бирюзовым спустя месяц после того, как в теме стал фиолетовым. Копировать
 * здесь больше нечего.
 */
export const Route = createFileRoute('/{-$locale}/_layout/design-system')({
  component: ShowcasePage,
  head: () => ({
    meta: [{ title: 'Design System | Teamplay.gg' }, { name: 'robots', content: 'noindex' }],
  }),
});
